const processInclude = require('base/util');

jQuery(() => {
    processInclude(require('./membership/membership-club'));
});
